import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/app/splitwise-alternative/SplitwiseAlternativeContent.tsx");
